import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostPollSucceed, EGetPostPollActionType } from './types';
import { IPostPoll } from '../../../types/postPoll';

export const getPostPollSucceed: (data: IPostPoll) => TGetPostPollSucceed = actionGenerator<
  EGetPostPollActionType.Succeed,
  IPostPoll
>(EGetPostPollActionType.Succeed);
